import { render } from "./HelpWidget.vue?vue&type=template&id=71ac9526"
import script from "./HelpWidget.vue?vue&type=script&lang=js"
export * from "./HelpWidget.vue?vue&type=script&lang=js"

import "./HelpWidget.vue?vue&type=style&index=0&id=71ac9526&lang=css"

import exportComponent from "/home/ubuntu/actions-runner/_work/frontend/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__